import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "instructor_container" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "avator" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "wrapper" }
const _hoisted_7 = { class: "insturctor" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = {
  key: 0,
  class: "level"
}
const _hoisted_10 = { class: "corporation" }
const _hoisted_11 = { class: "tag_group" }
const _hoisted_12 = {
  key: 0,
  class: "tag_item active"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "info" }
const _hoisted_15 = { class: "info_left" }
const _hoisted_16 = { class: "insturctor" }
const _hoisted_17 = { class: "name" }
const _hoisted_18 = {
  key: 0,
  class: "level"
}
const _hoisted_19 = { class: "corporation" }
const _hoisted_20 = { class: "tag_group" }
const _hoisted_21 = {
  key: 0,
  class: "tag_item active"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "data" }
const _hoisted_24 = { class: "data_item" }
const _hoisted_25 = { class: "data_value" }
const _hoisted_26 = { class: "data_label" }
const _hoisted_27 = { class: "data_item" }
const _hoisted_28 = { class: "data_value" }
const _hoisted_29 = { class: "data_label" }
const _hoisted_30 = {
  key: 2,
  class: "swiper_wrapper"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "list_item1 swiper_item" }
const _hoisted_33 = { class: "info" }
const _hoisted_34 = { class: "info_left" }
const _hoisted_35 = { class: "insturctor" }
const _hoisted_36 = { class: "name" }
const _hoisted_37 = {
  key: 0,
  class: "level"
}
const _hoisted_38 = { class: "corporation" }
const _hoisted_39 = { class: "tag_group" }
const _hoisted_40 = {
  key: 0,
  class: "tag_item active"
}
const _hoisted_41 = ["src"]
const _hoisted_42 = { class: "data" }
const _hoisted_43 = { class: "data_item" }
const _hoisted_44 = { class: "data_value" }
const _hoisted_45 = { class: "data_label" }
const _hoisted_46 = { class: "data_item" }
const _hoisted_47 = { class: "data_value" }
const _hoisted_48 = { class: "data_label" }

import { computed } from 'vue'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import CardTitle from './CardTitle.vue'
// import { useThemeColor } from '@/utils/theme'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useUsersStore } from '@/stores/users'
import { TabData } from '@/api/Models/AppTabs'


export default /*@__PURE__*/_defineComponent({
  __name: 'Instructor',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props

const instructorData = computed(() => {
  try {
    console.log(JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json))
    return JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json)
  } catch (error) {
    return []
  }
})
const type = computed(() => {
  try {
    return JSON.parse(props.data.extendInfo).layoutType
  } catch (error) {
    return {}
  }
})

const router = useRouter()
const skipHandle = (item: { id: string }) => {
  router.push({ path: '/lecturerDetail', query: { lecturerId: item.id } })
}

const usersStore = useUsersStore()
const { tabOptions } = storeToRefs(usersStore)
const hasLecturerNavgation = computed(() => {
  return tabOptions.value.find((item: TabData) => {
    return item.defaultCode === 'lecturer'
  })
})

const skipList = () => {
  return hasLecturerNavgation.value ? '/lecturerCenterTab' : '/lecturerCenter'
}

// const themeColor = useThemeColor()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CardTitle, {
      title: _ctx.data.title,
      class: "card_title",
      skipPage: skipList()
    }, null, 8, ["title", "skipPage"]),
    _createElementVNode("div", _hoisted_2, [
      (type.value === 1)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(instructorData.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list_item",
              key: index,
              onClick: ($event: any) => (skipHandle(item))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: item.avatarFileUrl,
                  class: "avator-img"
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(item.name), 1),
                  (item.lectureGradeName)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(item.lectureGradeName), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", _hoisted_10, _toDisplayString(item.companyName), 1),
                _createElementVNode("div", _hoisted_11, [
                  (item.teachingExperience)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.teachingExperience) + _toDisplayString(_ctx.$t('teaching_experience')), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 8, _hoisted_3))
          }), 128))
        : _createCommentVNode("", true),
      (type.value === 3)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(instructorData.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list_item1",
              key: index,
              onClick: ($event: any) => (skipHandle(item))
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(item.name), 1),
                    (item.lectureGradeName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(item.lectureGradeName), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(item.companyName), 1),
                  _createElementVNode("div", _hoisted_20, [
                    (item.teachingExperience)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(item.teachingExperience) + _toDisplayString(_ctx.$t('teaching_experience')), 1))
                      : _createCommentVNode("", true),
                    (item.tagNames)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.tagNames, (item1, index1) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: index1,
                            class: "tag_item active1"
                          }, _toDisplayString(item1), 1))
                        }), 128))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("img", {
                  src: item.avatarFileUrl,
                  class: "avator"
                }, null, 8, _hoisted_22)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("p", _hoisted_25, _toDisplayString(item.teachCourseNum), 1),
                  _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t('teach_course_num')), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("p", _hoisted_28, _toDisplayString(item.teachTotalDuration), 1),
                  _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t('teach_total_duration')), 1)
                ])
              ])
            ], 8, _hoisted_13))
          }), 128))
        : _createCommentVNode("", true),
      (type.value === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(instructorData.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                onClick: ($event: any) => (skipHandle(item))
              }, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("span", _hoisted_36, _toDisplayString(item.name), 1),
                        (item.lectureGradeName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(item.lectureGradeName), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_38, _toDisplayString(item.companyName), 1),
                      _createElementVNode("div", _hoisted_39, [
                        (item.teachingExperience)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(item.teachingExperience) + _toDisplayString(_ctx.$t('teaching_experience')), 1))
                          : _createCommentVNode("", true),
                        (item.tagNames)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.tagNames, (item1, index1) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: index1,
                                class: "tag_item active1"
                              }, _toDisplayString(item1), 1))
                            }), 128))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("img", {
                      src: item.avatarFileUrl,
                      class: "avator"
                    }, null, 8, _hoisted_41)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("p", _hoisted_44, _toDisplayString(item.teachCourseNum), 1),
                      _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.$t('teach_course_num')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("p", _hoisted_47, _toDisplayString(item.teachTotalDuration), 1),
                      _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t('teach_total_duration')), 1)
                    ])
                  ])
                ])
              ], 8, _hoisted_31))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})